<template>
    
    <div 
    
    class="w-full h-24 grid grid-cols-20 gap-6 odd:bg-gray-100 cursor-pointer hover:bg-gray-200" 
    
    @click="selectAppointment" 
    
    >

        <div class="flex items-center justify-center col-span-2" >

            <p class="w-auto inline-block text-sm px-3 py-1 bg-gray-200 rounded-lg" >{{ appointment.appointmentType }}</p>

        </div>

        <div class="flex items-center justify-start col-span-2" >

            <p class="w-auto inline-block text-sm px-3 py-1 bg-gray-200 rounded-lg" title="Clinic" >{{ appointment.clinicName }}</p>

        </div>

        <div class="flex flex-col justify-center col-span-4" >

            <p class="appointment-main-text" :title="appointment.animalName" > {{ appointment.animalName }} </p>

            <p class="appointment-secondary-text" >{{ appointment.id + ' / ' + appointment.id }}</p>

        </div>

        <div class="flex flex-col justify-center col-span-3" >

            <p class="appointment-main-text" :title="appointment.animalType" >{{ appointment.animalType }}</p>

            <p class="appointment-secondary-text" >{{ appointment.sex.toUpperCase() }}</p>

        </div>

        <div class="flex flex-col justify-center col-span-2" >

            <p class="appointment-main-text" >{{ appointment.species }}</p>

            <p class="appointment-secondary-text" >{{ appointment.sex.toUpperCase() }}</p>

        </div>

        <div class="flex flex-col justify-center col-span-2" >

            <p class="appointment-main-text" >{{ appointment.weight }}</p>

            <p class="appointment-secondary-text" >LBS</p>

        </div>

        <div class="flex items-center col-span-5" >

            <c-button 
            
            class="mr-2"
            title="Delete"
            icon="/images/icons/delete.svg"
            
            />

            <c-button 
            
            class="mr-2"
            icon="/images/icons/arrow-up-right.svg"
            
            />

            <c-button 
            
            class="mr-4"
            title="Edit"
            icon="/images/icons/edit.svg"

            @click="$router.push('/details')"
            
            />

            <button class="w-auto h-8 mr-4 text-sm px-3 bg-gray-200 hover:bg-gray-300 rounded-lg" >Send</button>

            <div 
            
            class="w-6 h-6 bg-gray-200 rounded-full flex items-center justify-center cursor-pointer" 

            :class="{ 'bg-green-500': selected }"
            
            >

                <img src="/images/icons/check-white.svg" alt="check" >

            </div>

        </div>

    </div>

</template>

<script>

    import { ref } from 'vue'

    import cButton from '../components/button.vue'

    export default {
    
        name: 'Appointment',

        components: { cButton },

        props: {
            selected: Boolean,
            appointment: Object
        },

        setup( props, { emit } ) {

            const selected = ref(false)

            const selectAppointment = () => {

                emit( 'select', props.appointment.id )

            }

            return {
                selectAppointment
            }

        }

    }

</script>

<style scoped>

    .appointment-main-text {
        @apply text-lg truncate;
    }

    .appointment-secondary-text {
        @apply text-xs text-gray-500 truncate;
    }

</style>